module.exports = __webpack_public_path__ + "img/add-retailer.4ed12fb9.svg";